import { useParams } from 'react-router-dom';

export const useParamsId = (key = 'id') => {
    const id = useParams()[key];
    return Number(id);
};
